import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

interface MainButtonProps {
  text: string;
  onClick: () => void;
  margin?: string;
  isSecondary?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

const MainButton: React.FC<MainButtonProps> = ({
  text,
  onClick,
  margin = '',
  isSecondary = false,
  disabled = false,
  loading = false,
}) => {
  return (
    <Button
      onClick={onClick}
      variant={isSecondary ? "outlined" : "contained"}
      color="primary"
      disabled={disabled || loading}
      style={{ margin, opacity: disabled ? 0.5 : 1 }}
      startIcon={loading ? <CircularProgress size={20} color="inherit" style={{ color: "var(--primary)" }} /> : null}
    >
      {loading ? 'Loading...' : text}
    </Button>
  );
};

export default MainButton;
